<template>
  <div class="home-page">
    <div class="home-content">
      <img src="../../assets/index.jpg" style="width:-webkit-fill-available;"/>
    </div>
    <div class="home-footer">
      <p>
        Copyright &copy; 2019-{{ currentYear }}
      </p>
      <p>
        沪 ICP 备 2021032637 号
      </p>
      <p>
        上海小着信息技术有限公司
      </p>
    </div>
  </div>
</template>

<script>
  export default {
    computed: {
      currentYear () {
        return (new Date()).getFullYear()
      }
    }
  }
</script>

<style lang="scss" scoped>
.home-page {
  background-color: #f5f5f5;

  .home-footer {
    padding: 3.59% 0;
    text-align: center;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    p {
      margin: 0;
      line-height: 14px;
      & + p {
        margin-top: 11px;
      }
    }
  }
}
</style>
